// Chinese (Simplified) translations
export const zh = {
  // Header
  header: {
    title: 'MicroGPT 实验室',
    subtitle: '交互式学习 microgpt',
    level: '关卡',
    params: '参数',
    badges: '徽章',
    train: '训练',
    star: '收藏'
  },

  // Navigation
  nav: {
    curriculum: '课程',
    content: '内容',
    visualization: '可视化'
  },

  // Levels
  levels: {
    completed: '已完成',
    locked: '已锁定',
    current: '当前关卡'
  },

  // Buttons
  buttons: {
    complete: '完成关卡',
    startLearning: '开始学习',
    trainAgain: '再次训练',
    reset: '重置',
    close: '关闭',
    cancel: '取消',
    confirm: '确定',
    showHint: '显示提示',
    showSolution: '显示答案',
    runCheck: '运行检查',
    randomize: '随机化'
  },

  // Training Experience
  training: {
    title: '训练 MicroGPT',
    intro: '实时观看语言模型训练和生成文本',
    starting: '开始训练...',
    training: '训练中...',
    generating: '生成样本...',
    complete: '训练完成！',
    lossLabel: '损失',
    stepLabel: '步骤',
    generatedNames: '生成的名字（幻觉生成！）',
    explanation: '这些名字是模型幻觉生成的 - 它从未见过这些名字！',
    pipeline: '完整的 MicroGPT 流程',
    comparison: '从此演示到 ChatGPT',
    thisDemo: '此演示',
    chatgpt: 'ChatGPT',
    sameAlgorithm: '相同的算法，不同的规模！'
  },

  // About Dialog
  about: {
    title: '关于 MicroGPT',
    subtitle: '大型语言模型的本质',
    whatIs: '什么是 MicroGPT？',
    whatIsDesc: 'MicroGPT 是 GPT 风格语言模型的最小化实现...',
    whatYoullLearn: '你将学到什么',
    fromMicroToMega: '从微型到大型',
    chatgptConnection: '与 ChatGPT 的联系',
    resources: '资源',
    resetProgress: '重置所有进度',
    resetProgressDesc: '清除所有已完成的关卡和获得的徽章',
    resetConfirm: '确定要重置所有进度吗？这将清除已完成的关卡和获得的徽章。'
  },

  // Code Exercise
  exercise: {
    description: '描述',
    template: '代码模板',
    hint: '提示',
    solution: '答案',
    useSolution: '使用此答案',
    attempts: '次尝试',
    attemptsPlural: '次尝试',
    checking: '检查中...',
    loading: '加载 Python 环境...',
    testPassed: '测试通过',
    testFailed: '测试失败',
    allTestsPassed: '所有测试通过！',
    someTestsFailed: '部分测试失败',
    tabSpaces: 'Tab = 4 个空格'
  },

  // Notifications
  notifications: {
    badgeEarned: '获得徽章',
    levelComplete: '关卡完成！',
    readyToLearn: '准备学习它是如何工作的！'
  },

  // Theme
  theme: {
    chooseTheme: '选择主题',
    selectScheme: '选择你喜欢的配色方案',
    dark: '深色',
    light: '浅色'
  },

  // Common
  common: {
    loading: '加载中...',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '信息'
  }
};
